export const filter = {
    id: "",
    name: "",
    rate: "",
    reverse_rate: "",
    reverse: '',
    code: '',
    symbol: ''
};
